import axios from 'axios';

const getItemsByEventId = async (eventId) => {
  const baseUrl = location.origin.includes('localhost') ? 'https://gillettefamilyfarms.com' : location.origin;
  const apiUrl = `${baseUrl}/wp-json/gff/v1`;
  const url = `${apiUrl}/events/${eventId}/admin/items`
  return (await axios.get(url))?.data || [];
}

export default { getItemsByEventId };